import { render, staticRenderFns } from "./MarksList.vue?vue&type=template&id=3c8edd85"
import script from "./MarksList.vue?vue&type=script&lang=js"
export * from "./MarksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports